export default "__VITE_ASSET__BxiEKJNV__"